import Constant from 'BASE/common/lotteryConstant';

const numberPlugin = {
    install: function (Vue, options) {
        Vue.prototype.$number = {
            /** 修正浮點數溢位 */
            fixFloatingNumber(value) {
                return parseFloat(value.toFixed(Constant.DecimalPrecision));
            },

            /** 加上千分位符號 */
            currency(value) {
                if (value === null || value === undefined) return '';
                return value
                    .toString()
                    .replace(/^(-?\d+?)((?:\d{3})+)(?=\.\d+$|$)/, function (all, pre, groupOf3Digital) {
                        return pre + groupOf3Digital.replace(/\d{3}/g, ',$&');
                    });
            },

            /** 修正浮點數溢位並且加上千分位符號 */
            fixFloatingNumberAndCurrency(value) {
                return this.currency(this.fixFloatingNumber(value));
            },
        };
    },
};

export default numberPlugin;
